import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GreenPower3Component } from './green-power3.component';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartModule } from 'primeng/chart';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MeterGroupModule } from 'primeng/metergroup';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@NgModule({
    declarations: [GreenPower3Component],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        ChartModule,
        DropdownModule,
        ButtonModule,
        InputSwitchModule,
        MeterGroupModule,
        TooltipModule,
        ConfirmDialogModule,
    ],
    exports: [
        GreenPower3Component
    ]
})
export class GreenPower3Module { }
